import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_NEWS_LIST_BY_ID](state, data) {
        state.newsList = data;
    },
    [action.GET_NEWS_SETTING_BY_ID](state, data) {
        state.newsSetting = data;
    },
    [action.GET_ANNOUNCEMENT_LIST](state, data) {
        state.announcementList = data;
    },
    [action.GET_ANNOUNCEMENT_BY_ID](state, data) {
        state.announcementDetails = data;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
};

export default mutations;
